import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import moment from "moment";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import {
  sendResalePurposes,
} from "../../../../../store/actions/eventsActions";
import { loadFile } from "../../../../../helpers/loadFile";
import Icon from "../../../../../components/UI/Icon/Icon";

import { getCustomURLs } from "../../../../../helpers/getCustomURLs";
import PleaseWaitModal from "../../../../BarCodes/modals/PleaseWaitModal";
import { executeAsyncWithModal } from "../../../../../helpers/modal";
import { Tooltip } from "../../../../../components/UI/Tooltip/Tooltip";

import "./EventReports.sass";
import { toast } from "react-toastify";

const { API_URL } = getCustomURLs();
const MySwal = withReactContent(Swal);

class EventReports extends Component {
  downloadExcelReport = (type) => {
    const { currentEvent } = this.props;
    let url = API_URL;
    const id = currentEvent.id;
    const name = currentEvent.name;
    let fileName = name.toLowerCase().replaceAll(" ", "_");
    let httpMethod = "GET";
    let ext = "csv";
    let body = undefined;

    switch (type) {
      case "tickets-report":
        httpMethod = "POST";
        fileName += "_tickets_report";
        url += `/EventReports/ByTicketTemplatesAtEvent?eventId=${id}&asCsv=true`;
        break;
      case "tickets-report2":
        fileName += "_tickets_report";
        url += `/Events/${id}/ByTicketTemplateReport`;
        break;
      case "transactions-report":
        fileName += "_transactions_report";
        url += `/Events/${id}/ByPaidTransactionsReport`;
        break;
      case "scanning-report":
        httpMethod = "POST";
        body = `{
                "eventId": "${currentEvent.id}",
                "fromTimeUtc": "${moment(currentEvent.startDate)
            .utcOffset(0, true)
            .add("hours", -12)
            .toISOString()}",
                "toTimeUtc": "${moment(currentEvent.endDate)
            .utcOffset(0, true)
            .add("hours", 6)
            .toISOString()}"
                }`;
        fileName += "_scan_report";
        url += `/EventReports/ByScanteamAtPeriod?asCsv=true`;
        break;
      case "presale-report":
        httpMethod = "GET";
        fileName += `_presale_report`;
        url += `/PreSale/${currentEvent.id}?asCsv=true`;
        break;
      default:
        fileName += "_scan_report";
        ext = "xls";
        url += `/ScanActions?eventId=${id}`;
        break;
    };

    MySwal.fire({
      html: <PleaseWaitModal message='Downloading file…' />,
      customClass: 'please-wait-modal',
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
    });

    axios({
      method: httpMethod,
      url,
      responseType: "arraybuffer",
      headers: {
        Authorization: `Bearer ${this.props.user.token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: body,
    })
      .then((response) => {
        loadFile(
          response.data,
          `${fileName}_${moment().format('DD_MM_YYYY_HH_mm')}.${ext}`
        );
      })
      .catch((error) => {
        toast.error(String(error.message))
      })
      .finally(() => {
        MySwal.close();
      });
  };

  sendResalePurposes = () => {
    const { id } = this.props.currentEvent;

    MySwal.fire({
      title: "Are you sure you want to send reselling offers?",
      text: "Users will receive resale offer emails",
      confirmButtonText: "Send",
      cancelButtonText: "Cancel",
      showCancelButton: true,
      showConfirmButton: true,
      reverseButtons: true,
      customClass: "warning-modal",
    }).then((result) => {
      if (result.value) {
        executeAsyncWithModal(
          () => this.props.sendResalePurposes(id),
          <PleaseWaitModal message="Preparing sending reselling offers...." />
        );
      }
    });
  };

  render() {
    const { currentEvent } = this.props;

    return (
      <div className="new-event__reports reports">
        <div
          className="reports__wrapper"
          onClick={() => this.downloadExcelReport("tickets-report")}
        >
          <Icon name="excel" />
          <button className="reports__button">
            Tickets Report
          </button>
        </div>
        <div
          className="reports__wrapper"
          onClick={() =>
            this.downloadExcelReport("transactions-report")
          }
        >
          <Icon name="excel" />
          <button className="reports__button">
            Transactions Report
          </button>
        </div>
        <div
          className="reports__wrapper"
          onClick={() => this.downloadExcelReport("scanning-report")}
        >
          <Icon name="excel" />
          <button className="reports__button">
            Scanning Report
          </button>
        </div>
        <div
          className="reports__wrapper"
          onClick={() => this.downloadExcelReport("presale-report")}
        >
          <Icon name="excel" />
          <button className="reports__button">
            Presale Report
          </button>
        </div>

        <div className="all-and-scanned">
          <div className="add-event__column">
            <div className="add-event__block reports__block">
              <label>
                All tickets
                <Tooltip
                  className="add-event__tooltip add-event__tooltip--color-grey"
                  description="Refunded, lost and cancelled tickets are included."
                >
                  <Icon name="info" />
                </Tooltip>
              </label>
              <span className="add-event__block__count">
                {currentEvent.allTickets}
              </span>
            </div>
            <div className="add-event__block reports__block">
              <label>Scanned tickets</label>
              <span className="add-event__block__count">
                {currentEvent.scannedTickets}
              </span>
            </div>
          </div>
        </div>

        <div
          className="add-event__column"
          style={{
            alignItems: "flex-end",
          }}
        >
          <div className="add-event__block">
            <button
              type="button"
              className="btn-primary btn-primary--reselling"
              onClick={this.sendResalePurposes}
            >
              Send reselling offers
            </button>
          </div>
        </div>
      </div>
    );
  }
};

const mapStateToProps = ({
  auth: { user },
  events: { currentEvent },
}) => ({ currentEvent, user });

const mapDispatchToProps = (dispatch) => ({
  sendResalePurposes: (eventId) => dispatch(sendResalePurposes(eventId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EventReports);
